import { PersonalizationActionTypes } from "../actions/Personalization";

function personalization(state = {}, action = {}) {
    switch (action.type) {
        case PersonalizationActionTypes.PERSONALIZATION_ERROR:
            return { ...state, shouldShowVideoList: true };
        case PersonalizationActionTypes.HANDLE_PERSONALIZATION_RESPONSE:
            return {
                ...state,
                videoList: action.data.videoList,
                shouldShowVideoList: true,
            };
        default:
            return state;
    }
}

export default personalization;
